module.exports = __webpack_public_path__ + "images/generic1-79dd64493ec34da5393dd223887d8dfa.jpg";